import {z} from 'zod';
import {date, id} from '../global/globalModels';
import {priorityRule} from '../bookingRules/priorityBooking';

export const bookingAvailabilityOtherBooking = z.object({
    id: id.nullable().optional(),
    profileImage: z.string().nullable().optional(),
    bookedCapacity: z.number().nullable(),
    initials: z.string().optional(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    from: z.coerce.date(),
    until: z.coerce.date(),
    comment: z.string().nullable().optional(),
});

export type BookingAvailabilityOtherBooking = z.infer<typeof bookingAvailabilityOtherBooking>;

export const bookingRestriction = z.object({
    from: date,
    until: date.nullable(),
    reason: z.string().nullable(),
});

export type BookingRestriction = z.infer<typeof bookingRestriction>;

export const bookingDateAvailability = z.object({
    from: z.coerce.date(),
    until: z.coerce.date(),
    availableCapacity: z.number().min(0),
    parallelCollisions: bookingAvailabilityOtherBooking.array(),
    blocked: z.boolean(),
    hasPermission: z.boolean(),
    occupiedBy: bookingAvailabilityOtherBooking.array().optional(),
    outOfBounds: z.boolean(),
    restrictions: bookingRestriction.array(),
    priorityRule: priorityRule.nullable(),
});

export type BookingDateAvailability = z.infer<typeof bookingDateAvailability>;

export const availabilityResponse = z.object({
    availabilities: bookingDateAvailability.array(),
});

export type AvailabilityResponse = z.infer<typeof availabilityResponse>;

export type BookingTimeframe = BookingDateAvailability & {
    checked: boolean;
    selectedCount: number;
};
